import {AssetMetaInterface} from '@taopix/taopix-core/dist/types/types';
import {
  PictureSortDirection,
  PictureSortType,
} from '../../Components/MediaGallery/MediaGalleryOptionsPopout';

export const sortImages = (
  sortBy: PictureSortType,
  sortDirection: PictureSortDirection,
  images: AssetMetaInterface[]
) => {
  const reverseSort = 'desc' === sortDirection;
  return images.sort((a: AssetMetaInterface, b: AssetMetaInterface) => {
    if ('datetimeoriginal' === sortBy) {
      // default to the fileDateModified
      let aDate: any = a.fileDateModified as unknown as string;
      let bDate: any = b.fileDateModified as unknown as string;

      if (!isNaN(Date.parse(a?.metaData?.dateTimeOriginal))) {
        aDate = a?.metaData?.dateTimeOriginal;
      }

      if (!isNaN(Date.parse(b?.metaData?.dateTimeOriginal))) {
        bDate = b?.metaData?.dateTimeOriginal;
      }

      aDate = Date.parse(aDate) / 1000;
      bDate = Date.parse(bDate) / 1000;

      if ('desc' === sortDirection) {
        return bDate - aDate;
      }
      return aDate - bDate;
    } else if ('name' === sortBy) {
      if (reverseSort) return b[sortBy].localeCompare(a[sortBy]);
      return a[sortBy].localeCompare(b[sortBy]);
    } else {
      if (a[sortBy] === b[sortBy]) {
        return 0;
      }

      return a[sortBy] > b[sortBy]
        ? reverseSort
          ? -1
          : 1
        : a[sortBy] < b[sortBy]
        ? reverseSort
          ? 1
          : -1
        : 0;
    }
  });
};
